import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57bdfd43&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/job-sagresimoveis/sagresimoveis-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VDivider,VFlex})
